module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-1.5fb25612.png";